import { render } from "./MainForm.vue?vue&type=template&id=99e9d406&lang=pug"
import script from "./MainForm.vue?vue&type=script&setup=true&lang=js"
export * from "./MainForm.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__